import { createStyles, makeStyles } from '@material-ui/core'
import colors from '../../../../../shared/style/colors'

export const useStyles = makeStyles(() =>
  createStyles({
    mainWrapper: {
      fontSize: '.875rem',
      color: colors.black
    },
    bottomSpace: {
      paddingBottom: '20px'
    },
    mainTitle: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '7px 32px',
      borderRadius: 0,
      width: '100%',
      fontWeight: 'normal',
      fontSize: '.875rem',
      '&:hover': {
        cursor: 'pointer',
        color: colors.white,
        background: '#CC0000 !important',
        backgroundImage: 'none',
        '& span > span': {
          backgroundImage: 'url(/assets/pictos/arrow-right-white.svg)'
        },
        '& span + span': {
          display: 'none !important'
        }
      }
    },
    subItemWrapper: {
      display: 'flex',
      flexDirection: 'column',
      background: colors.background,
      margin: '0 20px 0 20px',
      '& a': {
        padding: '0 10px',
        '&:hover': {
          fontWeight: 600
        },
        '&::before': {
          display: 'block',
          content: 'attr(title)',
          fontWeight: 'bold',
          height: 0,
          overflow: 'hidden',
          visibility: 'hidden'
        }
      }
    },
    subItem: {
      padding: '0 32px'
    },
    arrow: {
      backgroundImage: 'url(/assets/pictos/arrow-right.svg)',
      backgroundSize: 'contain',
      width: '10px',
      height: '10px'
    },
    open: {
      transform: 'rotate(90deg)',
      color: colors.white
    }
  })
)
